import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'lib-formly-textarea',
  imports: [
    NzFormModule,
    ReactiveFormsModule,
    CommonModule,
    NzInputModule,
    FormlyModule,
  ],
  templateUrl: './formly-textarea.component.html',
  styleUrl: './formly-textarea.component.scss',
})
export class FormlyTextareaComponent extends FieldType<FieldTypeConfig> {
  get errorState() {
    return this.showError ? 'error' : '';
  }
}
